import { Pipe, PipeTransform, inject } from '@angular/core';
import { ShipmentStatus } from '../enums';
import { Observable } from 'rxjs';
import { ShipmentStatusProviderService } from '../providers';

@Pipe({
  name: 'shipmentStatus',
})
export class ShipmentStatusPipe implements PipeTransform {
  private readonly provider = inject(ShipmentStatusProviderService);

  public transform(status: ShipmentStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
